

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { toast } from "react-toastify";
import axios from "axios";

const API_MAP = {
  library: "https://api.pidigihub.in/library",
  mentor: "https://api.pidigihub.in/mentors",
  exam: "https://api.pidigihub.in/exams",
  ebook: "https://api.pidigihub.in/ebook",
};

export default function CouponAdd() {
  const navigate = useNavigate();

  /* ────────────────  Local state ──────────────── */
  const [loading, setLoading] = useState(false); // save button
  // const [typeOptions, setTypeOptions] = useState([]); // items for dropdown
  const [isFetchingOptions, setIsFetchingOptions] = useState(false);

  const [formval, setFormval] = useState({
    coupon_Code: "",
    discount: "",
    valid_from: "",
    valid_till: "",
    category: "",
    forId: "",
    status: "true",
  });

  /* ────────────────  Handlers ──────────────── */
  const changeHandler = (e) => {
    let { name, value } = e.target;

    // always store coupon code in UPPERCASE
    if (name === "coupon_Code") value = value.toUpperCase();

    // when the user changes type, clear any previously selected target
    if (name === "category") {
      setFormval((prev) => ({ ...prev, [name]: value, forId: "" }));
      return; // `forId` cleared, fetch happens via useEffect below
    }

    setFormval((prev) => ({ ...prev, [name]: value }));
  };

  /* ────────────────  Fetch target list when type changes ──────────────── */
  // useEffect(() => {
  //   const type = formval.category;
  //   const url = API_MAP[type];

  //   // “All” or empty → nothing to fetch
  //   if (!url) {
  //     setTypeOptions([]);
  //     return;
  //   }

  //   (async () => {
  //     try {
  //       setIsFetchingOptions(true);
  //       const res = await axios.get(url, {
  //         headers: { Authorization: localStorage.getItem("token") },
  //       });
  //       // Some endpoints wrap the array in {data:[]}, others return [] directly
  //       const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
  //       // console.log(list);

  //     } catch (err) {
  //       console.error(err);
  //       toast.error("Failed to load list for selected type");
  //     } finally {
  //       setIsFetchingOptions(false);
  //     }
  //   })();
  // }, [formval.category]);

  /* ────────────────  Validation ──────────────── */
  const validateForm = () => {
    const { coupon_Code, discount, valid_from, valid_till, category, forId } =
      formval;

    if (!coupon_Code.trim())
      return toast.error("Coupon code is required"), false;
    if (!discount || discount <= 0 || discount > 100)
      return toast.error("Discount must be between 1 and 100"), false;
    if (!valid_from) return toast.error("Valid From date is required"), false;
    if (!valid_till) return toast.error("Valid Till date is required"), false;
    if (new Date(valid_till) <= new Date(valid_from))
      return toast.error("Valid Till must be after Valid From"), false;
    if (new Date(valid_from) < new Date().setHours(0, 0, 0, 0))
      return toast.error("Valid From date cannot be in the past"), false;

    // If a specific type was chosen, a target must be selected
    if (!category) return toast.error(`Please select a  category item`), false;

    return true;
  };

  /* ────────────────  Submit ──────────────── */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      code: formval.coupon_Code.trim(),
      discountType: "percentage",
      discountValue: formval.discount,
      validFrom: formval.valid_from,
      validTill: formval.valid_till,
      isActive: formval.status === "true",
      category: formval.category || "all",
    };

    // Dynamically attach the correct target field
    // switch (formval.category) {
    //   case "library":
    //     payload.libraryId = formval.forId;
    //     break;
    //   case "mentor":
    //     payload.mentorId = formval.forId;
    //     break;
    //   case "ebook":
    //     payload.ebookId = formval.forId;
    //     break;
    //   case "exam":
    //     payload.examId = formval.forId;
    //     break;
    //   // no extra field for “all”
    //   default:
    //     break;
    // }

    try {
      setLoading(true);
      const res = await axios.post(`${baseUrl}/coupons/add`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      if (res.status === 200 || res.status === 201) {
        toast.success("Coupon added successfully");
        setFormval({
          coupon_Code: "",
          discount: "",
          valid_from: "",
          valid_till: "",
          category: "",
          forId: "",
          status: "true",
        });

        navigate("/coupons");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to add coupon");
    } finally {
      setLoading(false);
    }
  };

  /* ────────────────  Render ──────────────── */
  const today = new Date().toISOString().split("T")[0];

  // helper: guess a label field (name / title / code)
  const getLabel = (item) =>
    // item?.name || item?.title || item?.code || item?._id;
    item?.mentorName ||
    item?.libraryName ||
    item?.bookTitle ||
    item?.exam_title;
  // mentorName libraryName bookTitle exam_title

  return (
    <section className="main-sec">
      {/*  Page Heading + Breadcrumb omitted for brevity  */}

      <div className="row">
        <div className="col-lg-12">
          <div className="cards edit-usr">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Coupon Code */}
                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Coupon Code<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    name="coupon_Code"
                    className="form-control"
                    value={formval.coupon_Code}
                    onChange={changeHandler}
                    required
                    style={{ textTransform: "uppercase" }}
                  />
                </div>

                {/* Discount */}
                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Discount (%)<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="number"
                    name="discount"
                    className="form-control"
                    value={formval.discount}
                    onChange={changeHandler}
                    min="1"
                    max="100"
                    required
                  />
                </div>

                {/* Coupon Type */}
                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Coupon Type<sup className="text-danger">*</sup>
                  </label>
                  <select
                    name="category"
                    className="form-control"
                    value={formval.category}
                    onChange={changeHandler}
                    required
                  >
                    {/* <option value="">Select Type</option>
                    <option value="all">All (Site‑wide)</option>
                    <option value="library">Library</option>
                    <option value="mentor">Mentor</option>
                    <option value="ebook">ebook</option>
                                      <option value="exam">Mock Test</option> */}
                    <option value="">Select Type</option>
                    <option value="all">All</option>
                    <option value="library">Library</option>
                    <option value="mentor">Mentor</option>
                    <option value="ebook">ebook</option>
                    <option value="exam">Exam</option>
                  </select>
                </div>

                {/* Target selector appears only when options are loaded */}

                {/* Valid From */}
                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Valid From<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="date"
                    name="valid_from"
                    className="form-control"
                    value={formval.valid_from}
                    onChange={changeHandler}
                    min={today}
                    required
                  />
                </div>

                {/* Valid Till */}
                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Valid Till<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="date"
                    name="valid_till"
                    className="form-control"
                    value={formval.valid_till}
                    onChange={changeHandler}
                    min={formval.valid_from || today}
                    required
                  />
                </div>

                {/* Status */}
                <div className="col-lg-6 mb-4">
                  <label className="form-label">Status</label>
                  <select
                    name="status"
                    className="form-control"
                    value={formval.status}
                    onChange={changeHandler}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>

                {/* Submit */}
                <div className="col-lg-12 text-center">
                  <button
                    type="submit"
                    className="btn-save"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Saving…
                      </>
                    ) : (
                      <>
                        <i className="fa fa-save me-1"></i>Save Coupon
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <style>
        {`
                      .btn-save {
          background: #008080;
          color: white;
          border: none;
          padding: 10px 30px;
          border-radius: 5px;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .btn-save:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
        }
        
        `}
      </style>
    </section>
  );
}
